import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; 
import carousel from 'vue-owl-carousel'
import store from './store' 
import request from '@/utils/request'

Vue.prototype.$globalImages = {
  data: {},
  news:{},
  urls: {},
  types: {},
  isLoaded: false
}

Vue.component('carousel', carousel)
Vue.use(ElementUI);

Vue.config.productionTip = false

// 完全禁用所有 console 输出
const noop = () => {};
console.log = noop;
console.info = noop;
console.warn = noop;
console.error = noop;
console.debug = noop;
console.trace = noop;
console.assert = noop;
console.clear = noop;
console.count = noop;
console.countReset = noop;
console.dir = noop;
console.dirxml = noop;
console.group = noop;
console.groupCollapsed = noop;
console.groupEnd = noop;
console.profile = noop;
console.profileEnd = noop;
console.table = noop;
console.time = noop;
console.timeEnd = noop;
console.timeLog = noop;
console.timeStamp = noop;


// 直接定义 getAllImages 函数
async function getAllImages() {
  try {
    const response = await request({
      url: '/resource/getAll',
      method: 'get'
    })
    return response
  } catch (error) {
    throw error
  }
}


async function getHomeNews() {
  try {
    const response = await request({
      url: '/news/home',
      method: 'get'
    })
    return response
  } catch (error) {
    throw error
  }
}

// 图片初始化函数
async function initAppImages() {
  try {
    const images = await getAllImages()
    const news = await getHomeNews()
    const newsMap = {}
    const imagesMap = {}
    const urlsMap = {}
    const typeMap = {}

    images.forEach(item => {
      imagesMap[item.name] = item
      urlsMap[item.name] = `${item.path}`
      typeMap[item.name] = `${item.type}`
    })
    news.forEach(item => {
      newsMap[item.id] = item
    })
    Vue.prototype.$globalImages.news = newsMap
    Vue.prototype.$globalImages.data = imagesMap
    Vue.prototype.$globalImages.urls = urlsMap
    Vue.prototype.$globalImages.types = typeMap
    Vue.prototype.$globalImages.isLoaded = true

    return true
  } catch (error) {
    Vue.prototype.$globalImages.isLoaded = false
    return false
  }
}

// 启动应用 - 删除重复的 new Vue()，只保留这一个
initAppImages().then(success => {
  
  // 只在这里创建 Vue 实例
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})